import React, { useEffect } from 'react';
import './about.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { FaHome, FaBuilding, FaHandshake, FaShieldAlt, FaPhoneAlt } from 'react-icons/fa';
import Topbar from './Topbar';
import SITELOGO from '../images/SITELOGO.jpg';
import LICARULPROFILE from '../images/LICARULPROFILE.jpeg'
export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>
    <div><Topbar/></div>
      <Navbar />
      <div className="container">
        {/* Header Section */}
        <section className="header-section">
        <center>
    <img src={SITELOGO} alt='appollo agency' title='appollo agency' width={300} height={250} className='img-fluid'/>
    </center>
          <h1>Welcome to Apollo Agency</h1>
          <p>Your Trusted Partner in Real Estate and Insurance Solutions</p>
        </section>

        {/* About Section */}
        <section className="about-section">
          <h2>About Us</h2>
          <center>
    <img src={LICARULPROFILE} alt='appollo agency' title='appollo agency' width={300} height={250} className='img-fluid'/>
    </center>

          <p>At Apollo Agency, we are dedicated to providing exceptional real estate and insurance services. With years of expertise, we specialize in helping clients buy, sell, rent, or lease houses, lands, offices, and shops. Our comprehensive approach ensures a seamless experience for all your real estate and insurance needs.</p>
          <p>Our team prioritizes trust, transparency, and professionalism in every transaction. Whether you are looking to purchase your dream home, lease a commercial property, or secure reliable insurance coverage, Apollo Agency is here to guide you every step of the way.</p>
          <p>We take pride in being more than a service provider; we are your partner in achieving your goals and securing your future.</p>
        </section>

        {/* Service Highlights Section */}
        <section className="services-section">
          <h2>Our Expertise</h2>
          <div className="service-card">
            <FaHome className="icon" />
            <h3>Residential Properties</h3>
            <p>Find your perfect home with our tailored buying, selling, and rental services. From cozy apartments to luxurious villas, we cater to all your residential property needs.</p>
          </div>
          <div className="service-card">
            <FaBuilding className="icon" />
            <h3>Commercial Properties</h3>
            <p>Explore opportunities in commercial real estate with our expert assistance. Whether it’s offices, shops, or warehouses, we help you buy, lease, or rent the right space for your business.</p>
          </div>
          <div className="service-card">
            <FaHandshake className="icon" />
            <h3>Land Transactions</h3>
            <p>Secure the perfect plot of land for your residential or commercial projects. We provide comprehensive support for buying, selling, or leasing lands in prime locations.</p>
          </div>
          <div className="service-card">
            <FaShieldAlt className="icon" />
            <h3>Insurance Services</h3>
            <p>Protect your investments and loved ones with our reliable insurance services. From property insurance to life coverage, we ensure you have peace of mind at every step.</p>
          </div>
        </section>

        {/* Mission Section */}
        <section className="mission-section">
          <h2>Our Mission</h2>
          <p>At Apollo Agency, our mission is to provide unparalleled real estate and insurance services that empower our clients to achieve their goals with confidence and ease.</p>
          <div className="mission-points">
            <div>
              <FaHandshake className="icon" />
              <p>Building lasting relationships through trust and transparency in every transaction.</p>
            </div>
            <div>
              <FaHome className="icon" />
              <p>Helping clients secure their dream properties and ensure a stress-free experience.</p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
  <div className="contact-container">
    <h2>Contact Us</h2>
    <p>We're here to assist you with your queries and requirements. Feel free to reach out anytime!</p>
    <div className="contact-details">
      <FaPhoneAlt className="icon contact-icon" />
      <p>
        Call us at: <a href="tel:+919884226561" className="contact-phone">+919884226561</a>
      </p>
    </div>
    <a href="tel:+919884226561" className="contact-btn">Get in Touch</a>
  </div>
</section>

      </div>
      <div>
        <Footer />
      </div>
    </>
  );
}
